import $ from 'jquery'
import Swiper, { Navigation, Pagination, Autoplay, fadeEffect } from 'swiper'

function initTooltip () {
  const tooltipsContent = document.querySelectorAll('[data-tooltip-content]')
  tooltipsContent.forEach(t => {
    t.classList.add('opacity-0')
    t.classList.add('invisible')
  })

  document.querySelectorAll('[data-tooltip-target]').forEach(function (icon) {
    icon.addEventListener('mouseover', function () {
      const target = icon.getAttribute('data-tooltip-target')
      const targetDOM = document.querySelector('#' + target)
      if (!targetDOM) return

      tooltipsContent.forEach(t => {
        t.classList.add('opacity-0')
        t.classList.add('invisible')
      })
      targetDOM.classList.remove('opacity-0')
      targetDOM.classList.remove('invisible')
    })

    icon.addEventListener('mouseleave', function () {
      const target = icon.getAttribute('data-tooltip-target')
      const targetDOM = document.querySelector('#' + target)
      if (!targetDOM) return

      targetDOM.classList.add('opacity-0')
      targetDOM.classList.add('invisible')
    })
  })
}

$(document).ready(() => {
  initTooltip()
  const variantsModal = document.querySelector('.variants__modal')
  if (!variantsModal) return
  const productPostContent = document.querySelector('main.entry-content')
  productPostContent.append(variantsModal)

  const infoList = variantsModal.querySelector('.modal__info')
  const variantSlider = variantsModal.querySelector('.swiper-wrapper')
  const currentVariantSlide = variantsModal.querySelector('.current-slide')
  const totalVariantSlides = variantsModal.querySelector('.total-slide')
  const modalCloseBtn = variantsModal.querySelector(
    '.variants__modal-button--close'
  )

  const variantBlock = document.querySelector('.variants-list')
  if (variantBlock) {
    const separator = variantBlock.querySelector('.variants-list__separator')
    const hiddenRow = variantBlock.querySelector(
      '.variants-list__grid:not(.first-row)'
    )
    const variantCards = variantBlock.querySelectorAll('.variant-card')

    if (separator !== null) {
      separator.addEventListener('click', function () {
        hiddenRow.classList.toggle('hide')
      })
    }

    // initialize swiper
    const modalVariantsCarousel = new Swiper('.modal__swiper', {
      loop: true,
      autoplay: {
        delay: 2000,
        pauseOnMouseEnter: false,
        disableOnInteraction: false,
        reverseDirection: false
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },

      // bullets
      pagination: {
        el: '.swiper-pagination'
      },

      // arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      on: {
        init: function (el) {
          currentVariantSlide.innerHTML = el.activeIndex + 1
          totalVariantSlides.innerHTML = el.slides.length
        },
        slideChange: function (el) {
          currentVariantSlide.innerHTML = el.activeIndex + 1
          totalVariantSlides.innerHTML = el.slides.length
        }
      }
    })
    const swiperControls = variantsModal.querySelector('.swiper-controls')

    // set default slides counter to 1
    if (variantsModal) {
      currentVariantSlide.innerHTML = '1'
      totalVariantSlides.innerHTML = '1'
    }

    // modals
    if (variantCards !== null) {
      variantCards.forEach((element, index) => {
        element.addEventListener('click', function (e) {
          // retrieve variation data
          retrieveVariation(element.dataset.variantId)
          // open the modal
          variantsModal.classList.remove('hidden')
          variantsModal.classList.add('open')
          document.body.classList.add('htr-modal-prevent-scroll')
          e.stopPropagation()
          // start carousel
          modalVariantsCarousel.autoplay.start()
          // calculate slides counter
          // --- on init
          modalVariantsCarousel.on('beforeTransitionStart', function (el) {
            currentVariantSlide.innerHTML = el.activeIndex + 1
            totalVariantSlides.innerHTML = Object.keys(el.slides).length
          })
          // --- on slide change
          modalVariantsCarousel.on('slideChangeTransitionEnd', function (el) {
            currentVariantSlide.innerHTML = el.activeIndex + 1
            totalVariantSlides.innerHTML = Object.keys(el.slides).length

            // console.log(swiperControls)
            if (Object.keys(el.slides).length < 1 && swiperControls) {
              swiperControls.style.visibility = 'hidden'
              // console.log('<=1', Object.keys(el.slides).length)
            } else if (Object.keys(el.slides).length > 1 && swiperControls) {
              swiperControls.style.visibility = 'visible'
              // console.log('>=1', Object.keys(el.slides).length)
            } else if (Object.keys(el.slides).length < 1 && !swiperControls) {
              // console.log('no carousel')
            }
          })
          // disabling card click
          variantBlock.classList.add('disable')

          document.body.classList.add('noscroll')
        })
      })
    }

    // Closing modal
    document.addEventListener('click', function (e) {
      if (variantsModal) {
        if (e.target != variantsModal && !variantsModal.contains(e.target)) {
          if (variantsModal.classList.contains('open')) {
            variantsModal.classList.remove('open')
            variantsModal.classList.add('hidden')
            document.body.classList.remove('htr-modal-prevent-scroll')

            // reset all fields
            infoList.innerHTML = ''
            variantSlider.innerHTML = ''
            currentVariantSlide.innerHTML = '1'
            totalVariantSlides.innerHTML = '1'
            // stop swiper
            modalVariantsCarousel.autoplay.stop()
            // enabling card click
            variantBlock.classList.remove('disable')
            document.body.classList.remove('noscroll')
            swiperControls.style.visibility = 'hidden'
          }
        }

        modalCloseBtn.addEventListener('click', function () {
          variantsModal.classList.remove('open')
          variantsModal.classList.add('hidden')
          document.body.classList.remove('htr-modal-prevent-scroll')

          // reset all fields
          infoList.innerHTML = ''
          variantSlider.innerHTML = ''
          currentVariantSlide.innerHTML = '1'
          totalVariantSlides.innerHTML = '1'
          // stop swiper
          modalVariantsCarousel.autoplay.stop()
          // enabling card click
          variantBlock.classList.remove('disable')
          document.body.classList.remove('noscroll')
          swiperControls.style.visibility = 'hidden'
        })
      }
    })

    if (separator) {
      separator.addEventListener('click', function () {
        separator.classList.toggle('expanded')
      })
    }
  }

  function retrieveVariation (id) {
    $.ajax({
      url: block_vars.url,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'block_variants_modal',
        variant_id: id,
        nonce: block_vars.nonce
      },
      success: function (data) {
        if (data.success === true) {
          document.querySelector('.modal__title').innerHTML = data.variant.title
          document.querySelector('.modal__description').innerHTML =
            data.variant.description

          // Form Variant Data
          let variantModalForm = document.querySelector('.variant-modal-form')
          if (variantModalForm) {
            variantModalForm.querySelector('.product_variant').value =
              data.variant.title
          }

          // data sources
          let dataInfo = data.variant.info
          let slideImages = data.variant.gallery

          // get and render info datas
          dataInfo.forEach(el => {
            // create and append variant infos
            let infoEl = document.createElement('div')
            let infoElIcon = document.createElement('img')

            infoEl.classList.add('el-content')
            infoEl.innerHTML = el.text

            infoList.appendChild(infoEl)

            infoElIcon.src = el.icon
            infoEl.appendChild(infoElIcon)
          })
          // get and render images url for swiper carousel
          slideImages.forEach(slideURL => {
            // create and appen swiper slides
            let variantSlide = document.createElement('div')
            let slideImage = document.createElement('img')

            variantSlide.classList.add('swiper-slide')
            variantSlider.appendChild(variantSlide)

            slideImage.src = slideURL
            variantSlide.appendChild(slideImage)
          })
        }
      },
      error: function (data) {
        // console.log("error")
      }
    })
  }
})
